import { businessService } from '@/pages/Business/services/business.service';
import type { BillingReportListResponse } from '../models/BillingReport';

export interface GetBillingReportsParams {
  page: number;
  pageSize: number;
}

const billingReportsApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getBillingReports: builder.query<BillingReportListResponse, GetBillingReportsParams>({
      query: ({ page, pageSize }) => ({
        url: 'billing-reports',
        params: {
          limit: String(pageSize),
          offset: String((page - 1) * pageSize),
        },
      }),
      providesTags: ['BillingReports'],
    }),
    getBillingReportDownloadUrl: builder.query<{ url: string }, string>({
      query: (id) => ({ url: `billing-reports/${id}/download-url` }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetBillingReportsQuery, useLazyGetBillingReportDownloadUrlQuery } =
  billingReportsApi;
